import DashboardSection from "./DashboardSection";

export default function TotalCapacity() {
	return (
		<DashboardSection
			className="p-2.5 pb-0 flex flex-col gap-2.5"
			title="Total Capacity (MW)"
		>
			<div className="w-full p-2.5 ps-0 flex items-center">
				<div className="flex-1 flex justify-center items-center text-xl font-bold leading-[100%] h-[30px] text-primary">
					6470
				</div>
				<div className="flex-1 flex justify-center items-center text-[10px] text-secondary leading-[100%] h-[30px]">
					*Excluding renewable energy
				</div>
			</div>
			<hr className="w-full border-[#C9C9C9] border-t-[0.3px] border-0" />
			<div className="w-full p-2.5 ps-0 flex items-center">
				<div className="flex-1 flex justify-center items-center flex-col gap-1.25 border-0 border-[#C9C9C9] border-r-[0.3px]">
					<h5 className="text-xl font-bold leading-[100%] text-primary">
						90.79%
					</h5>
					<p className="text-secondary text-[10px]">
						Energy Production Efficiency
					</p>
				</div>
				<div className="self-stretch mx-1"></div>
				<div className="flex-1 flex flex-col gap-2 w-full">
					{[
						{ label: "Generated (MW)", value: "3706" },
						{ label: "Target (MW)", value: "4427" },
					].map((item, index) => (
						<div key={index} className="flex items-center w-full">
							<p className="text-[10px] text-secondary leading-[100%] flex-grow">
								{item.label}
							</p>
							<p className="flex justify-center items-center w-[91px] leading-[100%] flex-shrink-0 text-base font-bold text-primary">
								{item.value}
							</p>
						</div>
					))}
				</div>
			</div>
		</DashboardSection>
	);
}
